module.exports = __webpack_public_path__ + "img/aiot_logo.8b97010b.png";